<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('breaktest.Header') }}</h2>

            </div>
        </div>
        <div id="image_holder" class="imageHolder" style="height:600px; display:flex">
            <div class="videos_listbox">
                <kendo-datasource ref="datasource"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-listbox ref="listbox"
                               :data-source-ref="'datasource'"
                               :data-text-field="'Titel'"
                               :data-value-field="'VideoPrim'"
                               :template="template"
                               @change="onQuestionChanged"
                               @databound="onDatabound"
                               style="height: 20vw;">
                </kendo-listbox>
            </div>
            <div class="video_player">
                <kendo-mediaplayer ref="mediaplayer"
                                   v-on:kendoready="kendoready"
                                   v-on:timechange="timechange"
                                   :media-title="'Example'"
                                   :media-source="''">
                </kendo-mediaplayer>
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';
    import { ListBox } from '@progress/kendo-listbox-vue-wrapper';
    import { DataSource } from '@progress/kendo-datasource-vue-wrapper';
    import { MediaPlayer } from '@progress/kendo-mediaplayer-vue-wrapper';
    import kendo from '@progress/kendo-ui';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-listbox': ListBox,
            'kendo-datasource': DataSource,
            'kendo-mediaplayer': MediaPlayer
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/VideosGruppe?RefVideosGruppe=4"
        },
        methods: {
            onQuestionChanged(e) {
                const baseUrl = config[0].BaseUrl;
                const element = e.sender.select();
                const dataItem = e.sender.dataItem(element[0]);
                const player = this.$refs.mediaplayer.kendoWidget();
                var path = baseUrl + dataItem.VideoPfad;
                var title = dataItem.Titel
                player.media({
                    source: path,
                    title: title,
                });
            },
            onDatabound() {
                const listbox = this.$refs.listbox.kendoWidget();
                if (listbox.items().length > 0) {
                    listbox.select(listbox.items()[0]);
                }
            },
            kendoready: function () {
                console.log('kendoready');
            },
            timechange: function () {
                console.log('timechange');
            },
            template: function (e) {
                var template = kendo.template('<p style="color:black">#=Titel#</p>');
                return template(e);
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>